<div class="w-100 h-100 d-flex flex-column py-2 px-2">
  <div class="d-flex align-items-center justify-content-between mb-2 w-100">
    <div class="fw-bold text-truncate flex-grow-1">
      {{ widgetData?.title || ('commentwidget.title' | translate) }}
    </div>
    <i class="bi bi-arrows-fullscreen text-primary" style="cursor: move;"></i>
  </div>

  <div class="comments-container flex-grow-1 overflow-auto">
    @if (isLoading) {
    <div class="text-center py-4">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">{{ 'commentwidget.loading' | translate }}</span>
      </div>
    </div>
    } @else if (comments.length === 0) {
    <div class="text-muted text-center py-4">
      <div>
        <i class="bi bi-chat-dots fa-2x mb-2"></i>
        <div>{{ 'commentwidget.noComments' | translate }}</div>
      </div>
    </div>
    } @else {
    <div class="comments-list">
      @for (comment of comments; track comment.id) {
      <div class="comment-card card mb-2">
        <div class="card-body p-2">
          <!-- En-tête avec avatar et auteur -->
          <div class="d-flex align-items-start mb-2">
            <div
              class="avatar bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-2"
              style="width: 40px; height: 40px; flex-shrink: 0;"
            >
              {{ comment.authorInitial }}
            </div>
            <div class="flex-grow-1">
              <div class="d-flex justify-content-between align-items-start">
                <div>
                  <div class="fw-bold small">
                    {{ comment.firstName }} {{ comment.lastName }}
                  </div>
                  <div class="text-muted" style="font-size: 0.75rem">
                    {{ comment.timeAgo }}
                  </div>
                </div>
                <div class="text-end">
                  @if (comment.companyName) {
                  <div>
                    <a
                      (click)="goToFolder(comment.companyId ?? null)"
                      class="text-decoration-none text-primary small d-inline-block"
                      style="cursor: pointer; max-width: 150px;"
                      [title]="comment.companyName"
                    >
                      <span class="text-truncate d-inline-block" style="max-width: 120px">
                        {{ comment.companyName }}
                      </span>
                    </a>
                  </div>
                  }
                </div>
              </div>
            </div>
          </div>

          <!-- Contenu du commentaire -->
          <div
            class="comment-content mb-2 small"
            [innerHTML]="sanitizeHtml(comment.content)"
          ></div>
        </div>
      </div>
      }
    </div>
    }
  </div>
</div>

